import React from 'react';
import {
	styled,
	webapi,
} from 'ps-gui';
import { ReactComponent as BankIdLogo }  from '../svg/bankidlogo.svg';
import { getPhrase } from '../data/phrases';

const Wrapper = styled.div`
	display: table;
	background: #000;
	color: #fff;
	font-weight: 600;
	border-radius: 4px;
	cursor: pointer;
	margin: ${props => props.margin};

	&:hover {
		.text {
			text-decoration: underline;
		}
	}

	.cell {
		display: table-cell;
		vertical-align: middle;
	}

	.bankIdLogo {
		display: block;
		width: 96.5px;
		height: 38.5px;
	}
	.text {
		padding-right: 12px;
		font-size: 14px;
		font-family: Poppins;
	}
	.separator {
		background: #fff;
		height: 20px;
		width: 1px;
		display: block;
		margin-right: 12px;
	}
`;

export default class BankIdButton extends React.PureComponent {

	constructor() {
		super();
		this.onBankIdLoginRequested = this.onBankIdLoginRequested.bind(this);
	}

	async onBankIdLoginRequested() {
		const url = await webapi.execute('get:/api/bi/loginUrl');
		window.location = url;
	}

	render() {
		return (
			<Wrapper onMouseDown={this.onBankIdLoginRequested} margin={this.props.margin}>
				<span className="cell"><BankIdLogo className="bankIdLogo"/></span>
				<span className="cell"><span className="separator"/></span>
				<span className="cell">
					<div className="text">
						{getPhrase('loginWithBankId')}
					</div>
				</span>
			</Wrapper>
		);
	}
}

